var AsyncRequestManager = function () {// eslint-disable-line no-unused-vars
    return {
        renderAsyncRequest: function (
            url,
            queryParameters,
            domElementToChange,
            replaceContent,
            language = 'en',
            domElementLoadingImage = '#mi-corpo-loading-image'
        ) {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: { language: language },
                success: function (data) {
                    if (domElementToChange != null) {
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                    $(domElementLoadingImage).css('display', 'none');
                }
            });
        },

        renderAsyncAppenderRequest: function (url, queryParameters, domElementToChange, language = 'en', domElementLoadingImage = '#mi-corpo-loading-image') {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: { language: language },
                success: function (data) {
                    if (domElementToChange != null) {
                        $(domElementToChange).append(data);
                    }
                    $(domElementLoadingImage).css('display', 'none');
                }
            });
        },

        renderAsyncRequestProductListing: function (
            url,
            queryParameters,
            domElementToChange,
            replaceContent,
            language = 'en',
            technologyFilter = '',
            fileButtonLabel = '',
            fileButtonCss = '',
            linkButtonLabel = '',
            linkButtonCss = '',
            linkButtonPath = ''
        ) {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: {
                    language: language,
                    technologyFilter: technologyFilter,
                    fileButtonLabel: fileButtonLabel,
                    fileButtonCss: fileButtonCss,
                    linkButtonLabel: linkButtonLabel,
                    linkButtonCss: linkButtonCss,
                    linkButtonPath: linkButtonPath
                },
                success: function (data) {
                    if (domElementToChange != null) {
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                    $('#mi-corpo-elcacolos-loading-img').css('display', 'none');

                }
            });
        },

        renderAsyncRequestProductListingForApplications: function (
            url,
            queryParameters,
            domElementToChange,
            replaceContent,
            language = 'en',
            applicationsFilters = '', // eslint-disable-line no-unused-vars
            fileButtonLabel = '',
            fileButtonCss = '',
            linkButtonLabel = '',
            linkButtonCss = '',
            linkButtonPath = '',
            filterType = ''// eslint-disable-line no-unused-vars
        ) {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: {
                    language: language,
                    technologyFilter: technologyFilter,// eslint-disable-line no-undef
                    fileButtonLabel: fileButtonLabel,
                    fileButtonCss: fileButtonCss,
                    linkButtonLabel: linkButtonLabel,
                    linkButtonCss: linkButtonCss,
                    linkButtonPath: linkButtonPath
                },
                success: function (data) {
                    if (domElementToChange != null) {// eslint-disable-line eqeqeq
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                }
            });
        },

        renderAsyncRequestProductListingForPackagingLayer: function (
            url,
            queryParameters,
            domElementToChange,
            replaceContent,
            language = 'en',
            packagingLayerFilters = '',// eslint-disable-line no-unused-vars
            fileButtonLabel = '',
            fileButtonCss = '',
            linkButtonLabel = '',
            linkButtonCss = '',
            linkButtonPath = '',
            filterType = ''
        ) {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: {
                    language: language,
                    applicationsFilters: applicationsFilters, // eslint-disable-line no-undef
                    fileButtonLabel: fileButtonLabel,
                    fileButtonCss: fileButtonCss,
                    linkButtonLabel: linkButtonLabel,
                    linkButtonCss: linkButtonCss,
                    linkButtonPath: linkButtonPath,
                    filterType: filterType
                },
                success: function (data) {
                    if (domElementToChange != null) {// eslint-disable-line eqeqeq
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                }
            });
        },

        renderSyncRequest: function (url, queryParameters, domElementToChange, language='en') {
            $.ajax({
                url: url + queryParameters,
                async: false,
                dataType: 'html',
                data: { language: language },
                success: function (data) {
                    if (domElementToChange != null) {// eslint-disable-line eqeqeq
                        $(domElementToChange).html(data);
                    }
                }
            });
        }
    };
};
